import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

const limit = 30;
export const fetchDocuments = createAsyncThunk(
  "documentList/fetch",
  async (data, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const { searchText, statusFilter, createdAtFilter, sort, page, typeFilter } =
        state.documentsList;

      const skip = limit * (page - 1);

      const where = {
        or: [{ title: { contains: searchText } }, { text: { contains: searchText } }],
        createdAt:
          createdAtFilter?.from && createdAtFilter?.to
            ? { ">=": createdAtFilter.from, "<=": createdAtFilter.to }
            : undefined,
        status: statusFilter?.length ? statusFilter.map(({ id }) => id) : undefined,
        category: typeFilter?.length ? typeFilter.map(({ id }) => id) : undefined,
        source: "migs",
        sourceOrganization: state.userAuthentication.user?.sourceOrganization,
      };

      const listPromise = axiosInstance.get(`${api.baseURL}document`, {
        params: {
          where,
          sort,
          limit,
          skip,
        },
      });
      const countPromise = axiosInstance.post(`${api.baseURL}document/count`, {
        where,
      });

      if (page === 1) {
        let [{ data: list }, { data: count }] = await Promise.all([listPromise, countPromise]);

        list = list.map(documentSanitizer);
        return [list, count];
      } else {
        let { data: list } = await listPromise;
        list = list.map(documentSanitizer);
        return [list];
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const documentSanitizer = (doc: any) => ({
  id: doc.id,
  category: {
    id: doc.category.id,
    name: doc.category.name,
  },
  title: doc.title,
  status: {
    name: doc.status.name,
    code: doc.status.code,
    module: doc.status.module,
  },
  createdAt: doc.createdAt,
  author: {
    name: doc.author.name,
  },
  thumbArchive: {
    id: doc.thumbArchive ? doc.thumbArchive.id : null,
  },
});
